import { render, staticRenderFns } from "./AvitoNewBuildingUpdateDialog.vue?vue&type=template&id=36f26fc3&"
import script from "./AvitoNewBuildingUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./AvitoNewBuildingUpdateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports